import React from 'react';
import IvicosStrings from 'kits/language/stringKit';
import { DefaultButton, DefaultEffects, Stack, Text } from '@fluentui/react';
import { IC } from 'components/SVGIcon';
import { ErrorSymbol } from 'kits/IconKit2';

type EtherpadAlertProps = {
    onClose: () => void;
    theme: any;
};
const EtherpadAlert: React.FC<EtherpadAlertProps> = ({ onClose, theme }) => (
    <Stack verticalAlign="center" style={{ width: '50vw', padding: '15px', margin: '0 auto', border: '6px solid red' }}>
        <Stack
            horizontalAlign="center"
            verticalAlign="center"
            style={{
                padding: '16px 26px',
                borderRadius: 4,
                boxShadow: DefaultEffects.elevation16,
                backgroundColor: theme.palette.orangeLighter
            }}
        >
            <IC size={128} variant="light">
                <ErrorSymbol />
            </IC>
            <Text variant="xLarge" style={{ color: '#fff', maxWidth: 700, textAlign: 'justify', marginBottom: 32 }}>
                {IvicosStrings.safariRoomCallDescription}
                <br />
                <br />
                {IvicosStrings.safariRoomCallDescriptionStep1}
                <br />
                {IvicosStrings.safariRoomCallDescriptionStep2}
                <br />
                {IvicosStrings.safariRoomCallDescriptionStep3}
            </Text>
            <DefaultButton text={IvicosStrings.closeActionTitle} onClick={onClose} style={{ marginBottom: 15 }} />
        </Stack>
    </Stack>
);

export default EtherpadAlert;
